import { render, staticRenderFns } from "./PosCustomerEntitlements.vue?vue&type=template&id=4aff708a&scoped=true"
import script from "./PosCustomerEntitlements.vue?vue&type=script&lang=js"
export * from "./PosCustomerEntitlements.vue?vue&type=script&lang=js"
import style0 from "./PosCustomerEntitlements.vue?vue&type=style&index=0&id=4aff708a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff708a",
  null
  
)

export default component.exports